import { Newsletter, NewsletterStatusEnum, LandingPage, SimpleNewsletter } from '@dev/ee-api/ee-api-models';
import { ActionCreator } from 'redux';
import { GetPaidNewslettersParams } from '@/services/ElasticApi';
import {
    PaidNewslettersActionTypes,
    ClearPreviewTemplateAction,
    DeletePaidNewsletterAction,
    DeletePaidNewsletterSuccessAction,
    DeletePaidNewsletterErrorAction,
    GetAllPaidNewslettersErrorAction,
    GetAllPaidNewslettersStartAction,
    GetAllPaidNewslettersSuccessAction,
    GetPaidNewsletterByNameErrorAction,
    GetPaidNewsletterByNameStartAction,
    GetPaidNewsletterByNameSuccessAction,
    LoadPreviewTemplateAction,
    LoadPreviewTemplateErrorAction,
    LoadPreviewTemplateSuccessAction,
    PickPaidNewslettersAction,
    PaidNewsletterListState,
    UnpickAllPaidNewslettersAction,
    UpdatePaidNewsletterStatusSuccessAction,
    UpdatePaidNewsletterStatusErrorAction,
    UpdatePaidNewsletterStatusStartAction,
    StdLoadListInterface,
} from './types';
import { ApplicationState } from '..';


export const GetAllPaidNewslettersStart: ActionCreator<GetAllPaidNewslettersStartAction> = (
    params: StdLoadListInterface
): GetAllPaidNewslettersStartAction => ({
    type: PaidNewslettersActionTypes.GET_ALL_PAID_NEWSLETTERS_START,
    payload: {
        loadingTemplates: true,
        page: params.page,
        limit: params.limit,
        search: params.search,
        statusList: params.statusList,
        from: params.from,
        to: params.to,
        offset: params.offset,
        scope: params.scope,
        isUrlUpdateDisabled: params.isUrlUpdateDisabled
    },
});

export const GetAllPaidNewslettersSuccess: ActionCreator<GetAllPaidNewslettersSuccessAction> = (
    list: SimpleNewsletter[],
    count: number,
    publishedCount?: number,
    unpublishedCount?: number,
): GetAllPaidNewslettersSuccessAction => ({
    type: PaidNewslettersActionTypes.GET_ALL_PAID_NEWSLETTERS_SUCCESS,
    payload: {
        loadingTemplates: false,
        templatesList: list,
        count,
        publishedCount,
        unpublishedCount
    },
});

export const GetAllPaidNewslettersError: ActionCreator<GetAllPaidNewslettersErrorAction>  = (): GetAllPaidNewslettersErrorAction => ({
    type: PaidNewslettersActionTypes.GET_ALL_PAID_NEWSLETTERS_ERROR,
    payload: {
        loadingTemplates: false,
    },
});

export const DeletePaidNewsletter = (paidNewsletterName: string[], UrlParams: GetPaidNewslettersParams): DeletePaidNewsletterAction => ({
    type: PaidNewslettersActionTypes.DELETE_PAID_NEWSLETTERS,
    payload: {
        Names: paidNewsletterName,
        UrlParams
    },
});
export const DeletePaidNewsletterSuccess = (): DeletePaidNewsletterSuccessAction => ({
    type: PaidNewslettersActionTypes.DELETE_PAID_NEWSLETTERS_SUCCESS
});
export const DeletePaidNewsletterError = (): DeletePaidNewsletterErrorAction => ({
    type: PaidNewslettersActionTypes.DELETE_PAID_NEWSLETTERS_ERROR
});

export const PickPaidNewsletters = (checkedPaidNewsletters: string[]): PickPaidNewslettersAction => ({
    type: PaidNewslettersActionTypes.PICK_PAID_NEWSLETTERS,
    payload: {
        checkedPaidNewsletters,
    },
});

export const UnpickAllPaidNewsletters = (): UnpickAllPaidNewslettersAction => ({
    type: PaidNewslettersActionTypes.UNPICK_PAID_NEWSLETTERS,
});

export const GetPaidNewsletterByNameStart = (
    name: string,
    isTemplateThumbnailsRequired = false
): GetPaidNewsletterByNameStartAction => ({
    type: PaidNewslettersActionTypes.GET_PAID_NEWSLETTER_BY_NAME_START,
    payload: { name, isTemplateThumbnailsRequired },
});

export const GetPaidNewsletterByNameSuccess = (
    singlePaidNewsletter: LandingPage,
): GetPaidNewsletterByNameSuccessAction => ({
    type: PaidNewslettersActionTypes.GET_PAID_NEWSLETTER_BY_NAME_SUCCESS,
    payload: {
        singlePaidNewsletter
    },
});

export const GetPaidNewsletterByNameError = (): GetPaidNewsletterByNameErrorAction => ({
    type: PaidNewslettersActionTypes.GET_PAID_NEWSLETTER_BY_NAME_ERROR,
});


export const LoadPreviewTemplate = (name: string): LoadPreviewTemplateAction => ({
    type: PaidNewslettersActionTypes.LOAD_PREVIEW_TEMPLATE,
    payload: {
        name,
        previewLoading: true
    },
});

export const LoadPreviewTemplateSuccess = (paidNewsletter: Newsletter): LoadPreviewTemplateSuccessAction => ({
    type: PaidNewslettersActionTypes.LOAD_PREVIEW_TEMPLATE_SUCCESS,
    payload: {
        paidNewsletter,
        previewLoading: false
    }

});

export const LoadPreviewTemplateError = (): LoadPreviewTemplateErrorAction => ({
    type: PaidNewslettersActionTypes.LOAD_PREVIEW_TEMPLATE_ERROR,
    payload: {
        previewLoading: false
    }
});

export const UpdatePaidNewsletterStatus = (name: string, status: NewsletterStatusEnum): UpdatePaidNewsletterStatusStartAction => ({
    type:  PaidNewslettersActionTypes.UPDATE_PAID_NEWSLETTER_STATUS,
    payload: {
        name,
        status
    }
});

export const UpdatePaidNewsletterStatusSuccess = (status: NewsletterStatusEnum, name: string): UpdatePaidNewsletterStatusSuccessAction => ({
    type:  PaidNewslettersActionTypes.UPDATE_PAID_NEWSLETTER_STATUS_SUCCESS,
    payload: {
        status,
        name
    }
});
export const UpdatePaidNewsletterStatusError = (name: string): UpdatePaidNewsletterStatusErrorAction => ({
    type:  PaidNewslettersActionTypes.UPDATE_PAID_NEWSLETTER_STATUS_ERROR,
    payload: {
        name
    }
});

export const ClearPreviewTemplate = (): ClearPreviewTemplateAction => ({
    type: PaidNewslettersActionTypes.CLEAR_PREVIEW_TEMPLATE,
    payload: null,
});

export const getPaidNewslettersStore = (state: ApplicationState): PaidNewsletterListState => state.paidNewslettersList;
